import React, { useState } from 'react';
import axios from 'axios';
import { Turnstile } from '@marsidev/react-turnstile';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faPhone } from '@fortawesome/free-solid-svg-icons';
import { useNavigate } from 'react-router-dom';

const ContactForm = () => {
  const navigate = useNavigate();
  const [formData, setFormData] = useState({
    name: '',
    email: '',
    phone: '',
    services: '',
    message: '',
  });
  const [turnstileToken, setTurnstileToken] = useState('');
  const [submitting, setSubmitting] = useState(false);
  const [error, setError] = useState('');

  const handleChange = (e) => {
    setFormData({ ...formData, [e.target.name]: e.target.value });
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    if (!turnstileToken) return;
    setSubmitting(true);
    setError('');
    try {
      const apiBase = process.env.REACT_APP_API_URL || 'http://localhost:3001';
      await axios.post(`${apiBase}/api/contacts`, { ...formData, turnstileToken });

      window.dataLayer = window.dataLayer || [];
      window.dataLayer.push({
        event: 'contact_form_submit',
        form_service: formData.services,
      });

      setFormData({ name: '', email: '', phone: '', services: '', message: '' });
      navigate('/thank-you');
    } catch (err) {
      setError(err.response?.data?.error || 'Something went wrong. Please try again.');
      setSubmitting(false);
    }
  };

  const serviceOptions = [
    'Hot Water Systems',
    'Water Leaks',
    'Bathroom & Kitchen',
    'Plumbing Maintenance',
  ];

  return (
    <form onSubmit={handleSubmit}>
      <div className="form-wrapper">

        <div className='field'>
          <label className="field-label">
            <span>Your Name *</span>
            <input type="text" name="name" value={formData.name} onChange={handleChange} required />
          </label>
        </div>

        <div className='field'>
          <label className="field-label">
            <span>Your Email *</span>
            <input type="email" name="email" value={formData.email} onChange={handleChange} required />
          </label>
        </div>

        <div className='field'>
          <label className="field-label">
            <span>Your Phone *</span>
            <input type="text" name="phone" value={formData.phone} onChange={handleChange} required />
          </label>
        </div>

        <div className='field'>
          <label className="field-label">
            <span>Select services *</span>
            <select name="services" value={formData.services} onChange={handleChange} required>
              <option value="">Select a service</option>
              {serviceOptions.map((option) => (
                <option key={option} value={option}>{option}</option>
              ))}
            </select>
          </label>
        </div>

        <div className='field'>
          <label className="field-label">
            <span>Your Message</span>
            <textarea name="message" value={formData.message} onChange={handleChange} required />
          </label>
        </div>

        {error && <p style={{ color: 'red', marginTop: 8 }}>{error}</p>}

      </div>

      <div style={{ margin: '16px 0' }}>
        <Turnstile
          siteKey={process.env.REACT_APP_TURNSTILE_SITE_KEY}
          onSuccess={setTurnstileToken}
          onError={() => setTurnstileToken('')}
          onExpire={() => setTurnstileToken('')}
          options={{ theme: 'light' }}
        />
      </div>

      <button type="submit" disabled={submitting || !turnstileToken}>
        {submitting ? 'Sending…' : 'Submit'}
      </button>

      <div className='row'>
        <div className='col col-100'>
          <h4 className='title'>Get in touch with Imperial PDG Support</h4>
        </div>
      </div>

      <div className='row'>
        <div className='col col-100'>
          <div className='button-holder'>
            <a href='tel:1300631226' className='btn-cust'>
              <span className='menu-icon step'>
                <span className='step-inner'>
                  <FontAwesomeIcon icon={faPhone} size='lg' color='black' />
                </span>
              </span>
              <span>Call us at 1300 631 226</span>
            </a>
          </div>
        </div>
      </div>

      <div className='row'>
        <div className='col col-100'>
          <h4 className='title business-hours'>Business Hours:</h4>
        </div>
      </div>

      <div className='row'>
        <div className='col col-50 left'>
          <p className='time'>Monday</p>
          <p className='time'>Tuesday</p>
          <p className='time'>Wednesday</p>
          <p className='time'>Thursday</p>
          <p className='time'>Friday</p>
          <p className='time'>Saturday</p>
          <p className='time'>Sunday</p>
        </div>
        <div className='col col-50 right'>
          <p className='time'>7 am - 5 pm</p>
          <p className='time'>7 am - 5 pm</p>
          <p className='time'>7 am - 5 pm</p>
          <p className='time'>7 am - 5 pm</p>
          <p className='time'>7 am - 5 pm</p>
          <p className='time'>7 am - 5 pm</p>
          <p className='time'>7 am - 5 pm</p>
        </div>
      </div>

    </form>
  );
};

export default ContactForm;
